import { Pipe, PipeTransform } from "@angular/core";
import { DateFormatterHelper } from "#helpers/date-formatter.helper";

@Pipe({
    name: "customDate",
    standalone: false
})
export class CustomDatePipe implements PipeTransform {
    transform(value: string | undefined, type?: string): string {
        const dateFormatterHelper = new DateFormatterHelper();

        if (
            !value ||
            value === null ||
            value === undefined ||
            value === "null" ||
            value === "undefined" ||
            value.length === 0
        ) {
            return "---";
        }

        if (!type) {
            return dateFormatterHelper.formatDateOnly(value);
        } else {
            switch (type) {
                case "dateOnly": // 'MMM DD, YYYY'
                    return dateFormatterHelper.formatDateOnly(value);
                case "shortDate": // 'M/d/YYY'
                    return dateFormatterHelper.formatShortDate(value);
                case "shortTime": // 'h:mm A'
                    return dateFormatterHelper.formatShortTime(value);
                case "1LineDate": // 'MMM DD, YYYY' 'h:mm A'
                    return dateFormatterHelper.formatDateOneLine(value);
                case "1LineDatePretty": // 'MMM DD, YYYY' at 'h:mm A'
                    return dateFormatterHelper.formatDateOneLinePretty(value);
                case "dateMMDDYYYY":
                    return dateFormatterHelper.formatDateMMDDYYYY(value);
                default:
                    // 'MMM DD, YYYY'
                    return dateFormatterHelper.formatDateOnly(value);
            }
        }
    }
}
